import { useState } from "react";
import Footer from "../../components/footer";
import { Button } from "@mui/material";
import SectionLoader from "../../layout/SectionLoader/SectionLoader";
import Navbar2 from "../../components/navbarhome";

const FAQ = () => {
    const [activeQuestion, setActiveQuestion] = useState(0);
    const [currentPage, setCurrentPage] = useState("provider");
    const [loading, setLoading] = useState(false);

    const handleClick = (index) => {
        setActiveQuestion(index);
    };

    const handlePageChange = (page) => {
        setLoading(true);
        setTimeout(() => {
            setCurrentPage(page);
            setLoading(false);
            setActiveQuestion(0);
        }, 500);
    };

    const providerQuestions = [
        
        {
            id: 1,
            question: "How do I apply for jobs on Resolab?",
            answer: "Create a profile, upload your resume, and start applying to open roles in your region."
        },
        {
            id: 2,
            question: "Is Resolab free for job seekers?",
            answer: "Yes, Resolab is completely free for candidates."
        },
        {
            id: 3,
            question: "What types of jobs are listed?",
            answer: "We list roles in the microfinance and financial inclusion space, including field officers, customer service, and team leads."
        },
        {
            id: 4,
            question: "How does the screening process work?",
            answer: "We conduct telephonic/video interviews and basic skill assessments to match you with the right employers."
        },
        {
            id: 5,
            question: "Will I get interview tips or help with resume building?",
            answer: "Yes! We offer training support, resume feedback, and mock interviews."
        }
    ];

    const seekerQuestions = [
        {
            id: 1,
            question: "What is Resolab and how does it work?",
            answer: "Resolab is a talent marketplace that connects microfinance institutions with pre-screened, job-ready candidates. Employers can post jobs, browse talent, and hire faster."
        },
        {
            id: 2,
            question: "What kind of talent is available on Resolab?",
            answer: "We focus on candidates suited for the microfinance sector - viz -  Loan Officers , Field Executives , Collection Executive , Branch Manager , Area/Regional/Zonal Manager and other functional role as well."
        },
        {
            id: 3,
            question: "How is Resolab different from a traditional job portal?",
            answer: "Unlike generic job portals, Resolab provides pre-vetted candidates, faster turnaround time, and tools tailored for microfinance hiring."
        },
        {
            id: 4,
            question: "Can I schedule interviews directly on the platform?",
            answer: "Yes, you can schedule, reschedule, and track interviews directly through Resolab."
        },
        {
            id: 5,
            question: "What are the pricing plans?",
            answer: "We offer subscription-based or pay-per-hire models. Contact us for a custom quote based on your hiring needs."
        },
        {
            id: 6,
            question: "How long does it take to fill a position?",
            answer: "With our active candidate pool and screening tools, most roles can be filled within 7–10 days."
        }
    ];

    const partnerQuestions = [
        {
            id: 1,
            question: "What is the Partner Program?",
            answer: "Our partner program allows individual to collaborate with Resolab."
        },
        {
            id: 2,
            question: "How can I become a Partner?",
            answer: "Contact our sales team to discuss partnership opportunities."
        }
    ];
    const platformQuestions = [
        {
            id: 1,
            question: "Is there a mobile app for Resolab?",
            answer: "Our mobile app is launching soon! Meanwhile, the platform is fully mobile-responsive."
        },
        {
            id: 2,
            question: "How do I get support if I have an issue?",
            answer: "You can reach us via email - connect@resolabindia.com we can reach out to you within 48 hours."
        },
        {
            id: 3,
            question: "Is my data safe on Resolab?",
            answer: "Yes, we use industry-standard security protocols to keep your data secure and private."
        }
    ];

    const questions = 
        currentPage === "provider" ? providerQuestions :
        currentPage === "seeker" ? seekerQuestions :
        currentPage === "partner" ? partnerQuestions :
        platformQuestions;

    return (
        <>
            <Navbar2 />
            <div className="w-full relative bg-white overflow-hidden flex flex-col items-start justify-start leading-[normal] tracking-[normal] mq800:gap-[0px] mq1150:gap-[50px]">
                <section className="self-stretch bg-darkslateblue-100 flex flex-col items-center justify-center pt-0 lg:px-5 box-border text-center text-45xl text-white font-dosis lg:pt-24">
                    <div className="w-full px-[45px] box-border">
                        <div className="flex flex-col items-center justify-center relative max-w-full gap-[40px]">
                            <img
                                className="lg:h-[350px] w-[full] absolute bottom-[0px] left-[-50px] z-[1] h-[0px]"
                                loading="lazy"
                                alt=""
                                src="/image-1@2x.png"
                            />
                            <div className="lg:py-[80px] py-[30px] flex flex-col items-center justify-center gap-[35px] z-[2]">
                                <h3 className="m-0 text-heading font-bold z-[2] mq800:text-32xl mq450:text-15xl">
                                    Frequently Asked Questions
                                </h3>
                                <div className="mt-1 button-container">
                                    <Button
                                        className={`nav-button mx-2 w-40 h-12 text-white ${
                                            currentPage === "seeker" ? "active" : ""
                                        }`}
                                        onClick={() => handlePageChange("seeker")}
                                    >
                                        MFI
                                    </Button>
                                    <Button
                                        className={`nav-button mx-2 w-40 h-12 text-white ${
                                            currentPage === "provider" ? "active" : ""
                                        }`}
                                        onClick={() => handlePageChange("provider")}
                                    >
                                        Talent
                                    </Button>
                                    <Button
                                        className={`nav-button mx-2 w-40 h-12 text-white ${
                                            currentPage === "partner" ? "active" : ""
                                        }`}
                                        onClick={() => handlePageChange("partner")}
                                    >
                                        Partner
                                    </Button>
                                    <Button
                                        className={`nav-button mx-2 w-40 h-12 text-white ${
                                            currentPage === "platform" ? "active" : ""
                                        }`}
                                        onClick={() => handlePageChange("platform")}
                                    >
                                        Platform
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {loading ? (
                    <div className="w-full flex justify-center items-center min-h-[300px]">
                        <SectionLoader />
                    </div>
                ) : (
                    <section className="self-stretch flex flex-row items-start justify-center py-10 px-5 box-border">
                        <div className="flex flex-row flex-wrap items-start justify-center lg:w-3/4 [row-gap:20px]">
                            {questions.map((question, index) => (
                                <div
                                    key={index}
                                    className={`rounded-xl min-w-full ${
                                        activeQuestion === index ? "bg-forestgreen text-white" : "bg-whitesmoke text-black"
                                    } flex flex-col items-start justify-start px-5 py-5 md:p-10 lg:p-5 cursor-pointer`}
                                    onClick={() => handleClick(index)}
                                >
                                    <div className="flex flex-row items-center justify-between w-full text-3xl">
                                        <b className="relative leading-[150%]">
                                            {question.question}
                                        </b>
                                        <img
                                            className="w-5 h-5"
                                            alt=""
                                            src={activeQuestion === index ? "/group.svg" : "/fi-9312231.svg"}
                                        />
                                    </div>
                                    {activeQuestion === index && (
                                        <div className="w-full text-3xl md:text-2xl lg:text-3xl leading-relaxed">
                                            {question.answer}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </section>
                )}

                <Footer
                    image58="/image-581@2x.png"
                    image60="/image-60@2x.png"
                    image581="/image-58-1@2x.png"
                    image601="/image-60@2x.png"
                />
            </div>
        </>
    );
};

export default FAQ;